import { captureConsoleIntegration } from '@sentry/browser';
import * as Sentry from '@sentry/react';
// import { BrowserTracing } from '@sentry/tracing';
import { VERSION } from './constants';

const environment = process.env.NODE_ENV;
const isDevelopment = process.env.NODE_ENV !== 'production';

export const sentryInit = () => {
  if (isDevelopment) return;

  /**
   * @See [Configuration](https://docs.sentry.io/platforms/javascript/guides/react/configuration/)
   */
  Sentry.init({
    dsn: 'https://cc2820f41307738b679299c5ea0e48cd@trace.tmapy.cz/10',
    release: VERSION,
    environment,
    integrations: [
      /*
       * BrowserTracing:
       *  - vklada hlavicku do requestu
       *  - neprojde pres CORS na kobru
       *  - je potreba podpora Sentry na backendu, aby to k necemu bylo
       */
      // new BrowserTracing(),

      captureConsoleIntegration({ levels: ['error', 'assert'] }), // 'warn',
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    beforeSend(event, hint) {
      // hint obsahuje originální error objekt
      const originalException = hint?.originalException;

      // Pokud je originalException undefined → chyba byla záměrně zachycena Sentry.captureException
      // Pokud je definovaná → unhandled chyba
      if (!originalException) {
        return null; // ignoruj handled chyby
      }

      // Jinak pošli do Sentry
      return event;
    },
  });
};
